import React, { useState } from "react";
import "../CSS/ApplyOnline.css";
import { Link } from "react-router-dom";

const Applyonline = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    city: "",
    documentType: "Educational",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formData.mobile.length !== 10) {
      alert("Please enter a valid 10 digit mobile number");
      return;
    }

    const text = `
📌 Apostille Apply Online Form

👤 First Name: ${formData.firstName}
👤 Last Name: ${formData.lastName}
📧 Email: ${formData.email}
📱 Mobile: ${formData.mobile}
🏙 City: ${formData.city}
📄 Document Type: ${formData.documentType}
📝 Message: ${formData.message}
`;

    const url = `https://wa.me/916393244687?text=${encodeURIComponent(text)}`;
    window.open(url, "_blank");

    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      mobile: "",
      city: "",
      documentType: "Educational",
      message: "",
    });
  };

  return (
    <section className="apply-online-page">
      <div className="apply-online-banner">
        <h1 className="apply-online-banner-title">Apostille Online</h1>

        <p className="apply-online-breadcrumb">
          <Link to="/">Home</Link> &gt;
          <span> Apostille Online</span>
        </p>
      </div>

      <div className="apply-online-layout">
        <aside className="apply-online-sidebar">
          <div className="apply-online-sidebox">
            <h3 className="apply-online-sidebox-title">APOSTILLE SERVICES</h3>
            <ul className="apply-online-side-list">
              <li className="apply-online-side-item">
                Educational Document Apostille
              </li>
              <li className="apply-online-side-item">
                Personal Document Apostille
              </li>
              <li className="apply-online-side-item">
                Commercial Document Apostille
              </li>
            </ul>
          </div>

          <div className="apply-online-sidebox">
            <h3 className="apply-online-sidebox-title">QUICK LINKS</h3>
            <ul className="apply-online-side-list">
              <li className="apply-online-side-item">
                Apostille Services in Mumbai
              </li>
              <li className="apply-online-side-item">
                Document Apostille Process
              </li>
              <li className="apply-online-side-item">
                MEA Approved Universities
              </li>
              <li className="apply-online-side-item">
                Apostille Country List
              </li>
              <li className="apply-online-side-item">
                Non Apostille Country List
              </li>
              <li className="apply-online-side-item">
                Apostille Accepted Embassy List
              </li>
              <li className="apply-online-side-item">
                Apostille Member Countries
              </li>
              <li className="apply-online-side-item">
                Apostille Centers – Mumbai
              </li>
            </ul>
          </div>
        </aside>

        <main className="apply-online-form-card">
          <h2 className="apply-online-form-title">Apply Online</h2>

          <form onSubmit={handleSubmit} className="apply-online-form">
            <div className="apply-online-form-row apply-online-form-row-two">
              <input
                type="text"
                placeholder="First Name"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                required
                className="apply-online-input"
              />

              <input
                type="text"
                placeholder="Last Name"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                required
                className="apply-online-input"
              />
            </div>

            <div className="apply-online-form-row apply-online-form-row-three">
              <input
                type="email"
                placeholder="Email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="apply-online-input"
              />

              <input
                type="text"
                placeholder="Mobile"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                required
                className="apply-online-input"
              />

              <input
                type="text"
                placeholder="City"
                name="city"
                value={formData.city}
                onChange={handleChange}
                required
                className="apply-online-input"
              />
            </div>

            <div className="apply-online-doc-type">
              <label className="apply-online-doc-label">Document Type</label>

              <div className="apply-online-radio-group">
                <label className="apply-online-radio-item">
                  <input
                    type="radio"
                    name="documentType"
                    value="Educational"
                    checked={formData.documentType === "Educational"}
                    onChange={handleChange}
                  />
                  Educational
                </label>

                <label className="apply-online-radio-item">
                  <input
                    type="radio"
                    name="documentType"
                    value="Personal"
                    checked={formData.documentType === "Personal"}
                    onChange={handleChange}
                  />
                  Personal
                </label>

                <label className="apply-online-radio-item">
                  <input
                    type="radio"
                    name="documentType"
                    value="Commercial"
                    checked={formData.documentType === "Commercial"}
                    onChange={handleChange}
                  />
                  Commercial
                </label>
              </div>
            </div>

            <textarea
              placeholder="Message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              className="apply-online-textarea"
            />

            <button type="submit" className="apply-online-submit-btn">
              SUBMIT
            </button>

            <p className="apply-online-mandatory">*All Fields are Mandatory</p>
          </form>
        </main>
      </div>
    </section>
  );
};

export default Applyonline;